import { Component, Input, OnChanges } from '@angular/core';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { DateRangeConfig, DateRangeValue, DateRangeOption } from '../../models/date-range-config.model';
import moment from 'moment';

@Component({
  selector: 'app-date-range',
  templateUrl: './date-range.component.html',
  styleUrls: ['./date-range.component.scss']
})
export class DateRangeComponent implements OnChanges {
  @Input() config!: DateRangeConfig;

  currentErrorMessage: string | undefined;
  currentValue: DateRangeValue = { startDate: null, endDate: null };
  selectedOption: DateRangeOption | null = null;

  private selectedStartDate: Date | null = null;
  private selectedEndDate: Date | null = null;

  ngOnChanges(): void {
    this.currentErrorMessage = this.config?.errorMessage;
    if (this.config?.value) {
      this.currentValue = { ...this.config.value };
    }
  }

  onStartDateChange(event: MatDatepickerInputEvent<Date>): void {
    if (!event.value) return;

    this.selectedStartDate = event.value;
    this.checkAndTriggerChange();
  }

  onEndDateChange(event: MatDatepickerInputEvent<Date>): void {
    if (!event.value) return;

    this.selectedEndDate = event.value;
    this.selectedStartDate = this.selectedStartDate || this.currentValue.startDate;
    this.checkAndTriggerChange();
  }

  onOptionSelected(option: DateRangeOption): void {
    this.currentErrorMessage = undefined;
    this.selectedOption = option;
    this.currentValue = { ...option.value };
    this.triggerChange();
  }

  closed(dateRangeStart: HTMLInputElement, dateRangeEnd: HTMLInputElement) {
    this.selectedStartDate = null;
    this.selectedEndDate = null;
  }



  private checkAndTriggerChange(): void {
    if (!isNaN(this.selectedStartDate?.getTime()) && !isNaN(this.selectedEndDate?.getTime())) {
      console.log("checkAndTriggerChange", this.selectedStartDate, this.selectedEndDate);
      console.log("currentValue", this.currentValue);
      const hasChanged = (this.currentValue.startDate?.getTime() !== this.selectedStartDate?.getTime()) ||
        (this.currentValue.endDate?.getTime() !== this.selectedEndDate?.getTime());
      this.currentValue.startDate = this.selectedStartDate;
      this.currentValue.endDate = this.selectedEndDate;
      this.selectedStartDate = null;
      this.selectedEndDate = null;
      if (hasChanged)
        this.triggerChange();
    }
  }

  private triggerChange(): void {
    if (this.config?.onValueChange) {
      this.config.onValueChange(this.currentValue);
    }
  }

  get startDate(): Date | null {
    return this.currentValue.startDate;
  }

  get endDate(): Date | null {
    return this.currentValue.endDate;
  }
}